module.exports = __webpack_public_path__ + "static/DylanKroftCV-936e0896baf2f1d04a6f66f209aeeb8c.pdf";